import Tooltip from '@ui-library/tooltip';
import React from 'react';
import Button from '@ui-library/button';
import { Flex } from '@ui-library/misc';
import { regular } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';

interface CopyToClipboardProps {
  content: string;
  children?: React.ReactNode;
}

const copy = (toCopytext: string) => {
  navigator.clipboard.writeText(toCopytext);
};

const CopyIcon = styled(FontAwesomeIcon)`
  color: initial;
`;

export default ({ children, content }: CopyToClipboardProps) => (
  <Tooltip title="Copied!" trigger="click">
    <Button textPrimary type="text" onClick={() => copy(content)} data-testid="copyButton">
      <Flex flexDirection="row" alignItemsCenter>
        <CopyIcon icon={regular('copy')} />
        <span className="p-l-sm">{children}</span>
      </Flex>
    </Button>
  </Tooltip>
);
